module.exports = __webpack_public_path__ + "static/media/clearnPark.c3dc14c7.png";